<template>
  <div class="os-history-item">
    <div class="os-history-item__header ">
      <div class="os-history-item__title">
        Изменен тип оплаты
        <span class="os-history-item__time">/ {{ item.createdAt | asFormattedTime }}</span>
      </div>

      <user-info-label :user="item.user" />
    </div>
    <div class="os-history-item__content">
      <before-after-log-item>
        <template v-slot:before>
          {{ oldPaymentTypeName }}
        </template>
        <template v-slot:after>
          {{ paymentTypeName }}
        </template>
      </before-after-log-item>
    </div>
  </div>
</template>

<script>
  import UserInfoLabel from '@/components/order-processing/order-components/history/order-state-history/items/parts/UserInfoLabel'
  import BeforeAfterLogItem
    from '@/components/order-processing/order-components/history/order-state-history/items/parts/BeforeAfterLogItem'
  import PaymentType from '@/models/enums/PaymentType'
  import PaymentMode from '@/models/enums/PaymentMode'
  import { mapState } from 'vuex'

  export default {
    name: 'HistoryItemTypePayment',
    components: { BeforeAfterLogItem, UserInfoLabel },
    props: {
      item: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      ...mapState({
        currentEditOrder: state => state.orders.currentEditOrder,
      }),
      paymentTypeName () {
        return PaymentType.getName(this.item.paymentType, this.currentEditOrder?.deliveryType, PaymentMode.ofOrder(this.currentEditOrder))
      },
      oldPaymentTypeName () {
        return PaymentType.getName(this.item.oldPaymentType, this.currentEditOrder?.deliveryType, PaymentMode.ofOrder(this.currentEditOrder))
      },
    },
  }
</script>

<style lang="less" scoped>
@import "./../OrderStateHistoryItem.less";
</style>
